import PopUp, { closeEveryModal } from "../../core/PopUp";
import PopUpDialog from "../../core/PopUpDialog";
import {
  IconAlertSquareRounded,
  IconEye,
  IconEyeOff,
  IconSettings,
  IconTrash,
} from "@tabler/icons-react";
import { useItemForm } from "../../../hooks/useItemForm";
import { ReactNode } from "react";
import { ITEM_STATUS, ItemStatusType } from "../../../types/Item.ts";
import { useItem } from "../../../fetch/fetch.item.ts";
import { EMPTY_ITEM } from "../../../const/typeDefault/Item.ts";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";

const SetStatus = ({
  itemId,
  onSuccess,
  children = null,
}: {
  itemId: string;
  onSuccess?: (itemId: string) => void;
  children?: ReactNode;
}) => {
  const { loading, setStatus } = useItemForm(itemId);
  const { item, isLoading, isError } = useItem(itemId, EMPTY_ITEM);

  const handleSubmit = async (state: ItemStatusType) => {
    if (isLoading || isError) return;
    const success = await setStatus(item, state);
    closeEveryModal();
    if (success && onSuccess) {
      onSuccess(itemId);
    }
  };
  if (isLoading)
    return (
      <PopUp
        id={`item-setting`}
        position="modal-bottom"
        title={
          <>
            <IconSettings />
            Anzeige
          </>
        }
      >
        {LOADING_CIRCLE}
      </PopUp>
    );
  if (item.status === ITEM_STATUS.DRAFT) {
    return (
      <PopUp
        id={`item-setting`}
        position="modal-bottom"
        title={
          <>
            <IconSettings />
            Anzeige
          </>
        }
      >
        <div className="flex flex-col gap-3">
          {children}
          <PopUpDialog
            title={
              <>
                <IconTrash />
                Löschen?
              </>
            }
            id={`dialog-item-delete`}
            description="Die Anzeige wird dauerhaft und unwiederruflich gelöscht."
            loading={loading}
            onClick={() => handleSubmit(ITEM_STATUS.DELETED)}
            className="btn text-error w-full"
          >
            <IconTrash />
            Löschen
          </PopUpDialog>
        </div>
      </PopUp>
    );
  }
  return (
    <PopUp
      id={`item-setting`}
      position="modal-bottom"
      title={
        <>
          <IconSettings />
          Anzeige
        </>
      }
    >
      <div className="flex flex-col gap-3">
        {children}
        <PopUpDialog
          title={
            <>
              <IconEye />
              Aktivieren?
            </>
          }
          id={`dialog-item-active`}
          description="Die Anzeige wird normal gelistet werden."
          loading={loading}
          onClick={() => handleSubmit(ITEM_STATUS.ACTIVE)}
          className="btn text-success w-full"
        >
          <IconEye />
          Aktivieren
        </PopUpDialog>

        <PopUpDialog
          title={
            <>
              <IconAlertSquareRounded />
              Reservieren?
            </>
          }
          id={`dialog-item-reserve`}
          description="Die Anzeige ist so gut wie verkauft aber du möchtest sie noch nicht löschen? Reserviere die Anzeige um sie nicht mehr zu listen und nur Nutzer mit dem Link können sie noch finden. Andere Nutzer können keinen neuen Chat eröffnen. "
          loading={loading}
          onClick={() => handleSubmit(ITEM_STATUS.RESERVED)}
          className="btn text-info w-full"
        >
          <IconAlertSquareRounded />
          Reservieren
        </PopUpDialog>
        <PopUpDialog
          title={
            <>
              <IconEyeOff />
              Verstecken?
            </>
          }
          id={`dialog-item-hide`}
          description="Möchtest du die Anzeige erst mit Bekannten teilen? Dann verstecke die Anzeige, damit sie nicht öffentlich gelistet wird. Jeder mit dem Link kann die Anzeige weiterhin finden und dich kontaktieren."
          loading={loading}
          onClick={() => handleSubmit(ITEM_STATUS.HIDDEN)}
          className="btn text-warning w-full"
        >
          <IconEyeOff />
          Verstecken
        </PopUpDialog>

        <PopUpDialog
          title={
            <>
              <IconTrash />
              Löschen?
            </>
          }
          id={`dialog-item-delete`}
          description="Die Anzeige wird dauerhaft und unwiederruflich gelöscht."
          loading={loading}
          onClick={() => handleSubmit(ITEM_STATUS.DELETED)}
          className="btn text-error w-full"
        >
          <IconTrash />
          Löschen
        </PopUpDialog>
      </div>
    </PopUp>
  );
};
export default SetStatus;
